import { initBreakpointChangeEvent, setViewport } from './modules/checkScreen'
import initHeader from './modules/header'
import initNavGlobal from './modules/navGlobal'
import initFrameLeft from './modules/frameLeft'
import initGalleryModal from './modules/galleryModal'
import cloneDetailImage from './modules/cloneDetailImage'
import articleArchive from './modules/articleArchive'
import bgRandom from './modules/bgRandom'
import top from './pages/top'
import detail from './pages/detail'

/* ----------------------------------------------------------
  Common
---------------------------------------------------------- */
setViewport()
initBreakpointChangeEvent()
initHeader()
initNavGlobal()
initFrameLeft()
initGalleryModal()
cloneDetailImage()
bgRandom()
articleArchive()

/* ----------------------------------------------------------
  Pages
---------------------------------------------------------- */
const pageId = document.getElementsByTagName('body')?.[0]?.id
const pageModule = {
  top,
  detail,
}

if (pageId && pageModule?.[pageId]) {
  pageModule[pageId]()
}
